import styled from 'styled-components';
import { MenuItem as MuiMenuItem, Popover } from '@mui/material';

import { Button } from 'components/Button';

export const CompletedButton = styled(Button)`
  pointer-events: none;
  svg {
    margin-right: 8px;
  }
`;

export const MarkCompletedButton = styled(Button)`
  width: max-content;
  svg {
    margin-right: 8px;
  }
  width: max-content;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-content: center;
  justify-content: space-between;
  button {
    margin-left: 1rem;
  }
`;
export const StyledPopover = styled(Popover)`
  box-shadow: none;
  border: none;
  border-radius: 8px;
`;

export const MenuItem = styled(MuiMenuItem)`
  font-size: 14px;
  height: 50px;
  padding: 6px 16px;
  background: ${({ theme }) => theme.palette.common.white};
  display: flex;
  width: 124px;
  box-shadow: ${({ theme }) => theme.shadows.card};
`;

export const ModalText = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.15px;
  margin: 0;
`;
